import { ActivitiesRequests } from '@/services/activities.requests'
import { getWorkingHoursForDate } from '@/lib/helpers/WorkingHours.js'
import moment from 'moment'
const activitiesService = new ActivitiesRequests()

const state = {
  categories: [],
  activities: [],
  catalog: null,
  extendedActivity: null,
  workingHours: [],
  slots: null,
  capacityPerSlot: [],
  storedSlots: {},
}

const getters = {
  onlyCategoriesWithActivities: state => {
    var categoryIds = []
    state.activities.forEach(item => {
      item.activity.categoryIds.forEach(id => {
        if (!categoryIds.includes(id)) {
          categoryIds.push(id)
        }
      })
    })
    return state.categories.filter((item) => {
      return categoryIds.includes(item.id)
    })
  },
  activitiesByCategory: (state) => (categoryId) => {
    return state.activities.filter(item => {
      return item.activity.categoryIds.includes(categoryId)
    })
  },
  activityById: (state) => (id) => {
    return state.activities.find(item => {
      return item.activity.id === id
    })
  },
  productById: (state) => (id) => {
    var prod = state.catalog.products.find(item => {
      return item.product.id === id
    })
    if (prod) { return prod } else {
      state.catalog.categories.forEach(cat => {
        prod = cat.products.find(prod => {
          return prod.product.id === id
        })
      })
      if (prod) { return prod } else { return null }
    }
  },
  categoryById: (state) => (id) => {
    return state.catalog.categories.find(item => {
      return item.category.id === id
    })
  },
  currencies: (state) => {
    return state.extendedActivity ? state.extendedActivity.activity.currencies : null
  },
}

const actions = {
  listCategories ({ state }) {
    if (state.categories.length === 0) {
      return new Promise((resolve, reject) => {
        activitiesService.listActivityCategories().then((activityCategories) => {
          state.categories = activityCategories
          resolve(activityCategories)
        }).catch((error) => {
          reject(error)
        })
      })
    }
  },
  listActivities ({ state }) {
    if (state.activities.length === 0) {
      return new Promise((resolve, reject) => {
        activitiesService.listActivities().then((activities) => {
          var filteredList = activities.filter((item) => {
            return item.activity.active
          })
          state.activities = filteredList
          resolve(filteredList)
        }).catch((error) => {
          reject(error)
        })
      })
    }
  },
  getActivity ({ state }, { id }) {
    return new Promise((resolve, reject) => {
      activitiesService.getActivity(id).then((extendedActivity) => {
        state.extendedActivity = extendedActivity
        resolve(extendedActivity)
      }).catch((error) => {
        reject(error)
      })
    })
  },
  getWorkingHours ({ state, dispatch }, { id, start, end, date, storeSlots }) {
    // Obtiene los horarios de una actividad
    return new Promise((resolve, reject) => {
      activitiesService.getWorkingHours(id, { start, end, date }).then((workingHours) => {
        state.workingHours = workingHours
        if (storeSlots) {
          dispatch('storeSlots', { id, start, end, workingHours }).then(() => {
            resolve(workingHours)
          })
        } else {
          resolve(workingHours)
        }
      }).catch((error) => {
        reject(error)
      })
    })
  },
  getSlots ({ state }, { id, date, save }) {
    return new Promise((resolve, reject) => {
      if (save) {
        state.slots = null
      }
      activitiesService.getSlots(id, date).then((slots) => {
        if (save) {
          state.slots = slots
        }
        resolve(slots)
      }).catch((error) => {
        reject(error)
      })
    })
  },
  listCapacityPerSlot ({ state }, { id, save, since, until }) {
    return new Promise((resolve, reject) => {
      activitiesService.listCapacityPerSlot(id, since, until).then((capacityPerSlot) => {
        if (save) {
          state.capacityPerSlot = capacityPerSlot
        }
        resolve(capacityPerSlot)
      }).catch((error) => {
        reject(error)
      })
    })
  },
  getCatalog ({ state }, { id }) {
    return new Promise((resolve, reject) => {
      state.catalog = null
      activitiesService.getCatalog(id).then((catalog) => {
        state.catalog = catalog
        resolve(catalog)
      }).catch((error) => {
        reject(error)
      })
    })
  },
  storeSlots ({ state, dispatch }, { id, start, end, workingHours }) {
    let startDate = moment(start, 'YYYY-MM-DD')
    let endDate = moment(end, 'YYYY-MM-DD')
    const promises = []
    for (let day = startDate; day.isSameOrBefore(endDate); day.add(1, 'd')) {
      var get = true
      if (workingHours) {
        const dateMoment = moment(day).startOf('day').add(1, 'ms')
        const foundWorkingHours = getWorkingHoursForDate(dateMoment, workingHours)
        if (!foundWorkingHours) {
          get = false
        }
      }
      if (get) {
        const dayString = day.format('YYYY-MM-DD')
        promises.push(dispatch('getSlots', { id, date: dayString }).then((slots) => {
          state.storedSlots[dayString] = slots
        }))
      }
    }
    return Promise.all(promises).catch(() => {})
  },
}

const mutations = {
  resetActivityData (state) {
    state.slots = null
    state.workingHours = []
    state.extendedActivity = null
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
